export const EMAIL_VERIFICATION_TOKEN_SEARCH_PARAM = 'emailVerificationToken'
